import { Format } from "./format";

export const today = new Date()
export const now   = () => new Date()
export const isSameDay = (a?: string | Date | null, b?: string | Date | null) => {
  if (!a || !b) return false;

  const d1 = new Date(a);
  const d2 = new Date(b);

  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
};

export const isToday = (date?: Date | null | undefined) =>  {
  if (date === null || date === undefined) {
    return false
  }

  const d1 = new Date(now());
  const d2 = new Date(date);

  return (
    d1.getUTCFullYear() === d2.getUTCFullYear() &&
    d1.getUTCMonth() === d2.getUTCMonth() &&
    d1.getUTCDate() === d2.getUTCDate()
  );
}

type ConvertToDateOrNull<T> = T extends string ? Date : null;

// todo: usar Options pra simplificar isso
export function toDate<T extends string | undefined>(a: T): ConvertToDateOrNull<T> {
  if (typeof a === 'string') {
    return new Date(a) as ConvertToDateOrNull<T>;
  }
  return null as ConvertToDateOrNull<T>;
}

/**
 * @param {string} isoString string no formato 'YYYY-MM-DD' como '2020-02-23'
 * esse é o formato padrão retornado pelo <input> html
 */

export function invertedStringToDate(isoString: null) : null;
export function invertedStringToDate(isoString: undefined) : null;
export function invertedStringToDate(isoString: string) : Date;
export function invertedStringToDate(isoString?: string | null) {
  if (!isoString) {
    return null
  }
  const [year, month, day] = isoString.split('-');
  return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
}
